/* eslint-disable comma-dangle */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'AboutCompetitionBlock';
const CLS = 'aboutCompetitionBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/aboutCompetitionBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import utils from '../utils';

export class AboutCompetitionBlock {
	constructor($el) {
		// $el is the widget node return by the loadAboutCompetitionBlock function
		this.$el = $el;
	}

	init() {
		this.setAboutCompetitionBlock();
	}

	setAboutCompetitionBlock() {
		// Add Some logic here
		const $wg = $(this.$el);
		let animationOffset = 30;
		if (!$wg.find('.container').hasClass('sec--fadeIn')) {
			$wg.find('.container').addClass('sec--fadeIn');
		}
		let aboutCompetitionBlockText = $wg.find(WG + 'text');
		let aboutCompetitionBlockImages = $wg.find(WG + 'images');
		if (!$wg.hasClass(WG + '-flipped')) {
			aboutCompetitionBlockText.css('left', -animationOffset + 'px');
			aboutCompetitionBlockImages.css('right', -animationOffset + 'px');
		} else {
			aboutCompetitionBlockText.css('right', -animationOffset + 'px');
			aboutCompetitionBlockImages.css('left', -animationOffset + 'px');
		}

		$(window).on('scroll', function() {
			if (!utils.isElementOutViewport($wg)) {
				if (parseInt($wg.find('.container').css('opacity')) === 0) {
					$wg.find('.container').animate({
						'opacity': '1'
					}, 1500);
				}
				// if an aboutCompetitionBlock
				aboutCompetitionBlockText.animate({
					'left': '',
					'right': ''
				}, 1000);
				aboutCompetitionBlockImages.animate({
					'left': '',
					'right': ''
				}, 1000);
			}
		});

		$(window).trigger('scroll');
	}

	// Add more functions like on above here
}
